import {i18n} from '@/plugins/i18n'

export const walletWageType = {
    SAME_AS_GLOBAL: 1,
    CONSTANT: 2,
    PERCENT: 3,
    LIMITED_PERCENT: 4,
};

export const walletWageTypeStr = {
    SAME_AS_GLOBAL: i18n.t('wallets.wage_type.same_as_global'),
    CONSTANT: i18n.t('wallets.wage_type.constant'),
    PERCENT: i18n.t('wallets.wage_type.percent'),
    LIMITED_PERCENT: i18n.t('wallets.wage_type.limited_percent'),

    get(type) {
        let type_str = null;

        Object.keys(walletWageType).forEach(item => {
            if (walletWageType[item] === type) {
                type_str = walletWageTypeStr[item];
            }
        });

        return type_str;
    }
};
